import React from 'react';
import {
  ClipboardDocumentCheckIcon,
  CalendarDaysIcon,
  ClockIcon,
} from '@heroicons/react/24/solid';
import { Columns3 } from 'lucide-react';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

// Wrapper de compatibilidade — preserva a assinatura original (activeTab).
// Implementação real em shared_items/NavbarBottom.jsx (design-system fase 2). Remover em fase 3.
const TABS = [
  { key: 'todo', label: 'To-Do', Icon: ClipboardDocumentCheckIcon },
  { key: 'events', label: 'Tasks & Events', Icon: ClockIcon },
  { key: 'calendar', label: 'Calendar', Icon: CalendarDaysIcon },
  { key: 'projects', label: 'Projects', Icon: Columns3 },
];

const NavbarBottom = ({ activeTab, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTab}
    onTabChange={handleTabChange}
    moduleKey="planner"
    layout="grid-4"
    textSize="tight"
    zIndexClass="z-10"
  />
);

export default NavbarBottom;
